module.exports = __webpack_public_path__ + "img/coal.959d14c.jpg";